import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar"
import { APP_DOMAIN } from '../../constants/constants';
import { circleColor } from '../../helper';
const ResumeStrengthDesktopView = ({ strength, scorePoint}) => {
  const circleinsideColor = {
    color: circleColor(scorePoint)
  };
    return (
        <><div className="circle-dimension">
          <CircularProgressbarWithChildren value={scorePoint} strokeWidth="7" styles={buildStyles({ textColor: '#815500', textSize: '28px', trailColor: '#E8E8E8',background: {
      fill: '#3e98c7',
    }, pathColor:  circleColor(scorePoint) })}>
            <div className="score" style={circleinsideColor}>{!isNaN(scorePoint) ? `${scorePoint}%` : <img src={`${APP_DOMAIN}/assets/images/question.svg`} />}</div>
            <div className="strength" style={circleinsideColor}>
              {strength??null}
            </div>
          </CircularProgressbarWithChildren>
        </div>
        <span>Power Score</span>
        </>
    );
};

export default ResumeStrengthDesktopView;
